import { isNil } from "lodash";
import PropTypes from "prop-types";
import React, { Fragment, useCallback } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import { withContainerContext } from "../../components/container/ContainerContext";
import DrawerView from "../../components/drawerView";
import InspectorBottomBox from "../../components/inspector/InspectorBottomBox";
import InspectorEmptyBox from "../../components/inspector/InspectorEmptyBox";
import InspectorField from "../../components/inspector/InspectorField";
import Icon from "../../components/interface/Icon";
import TabLock from "../../components/tabLock";
import TabView from "../../components/tabView";
import interfaceIdentifiers from "../../constants/interfaceIdentifiers";
import dialogs from "../../dialogs";
import { appStateOperations, appStateSelectors } from "../../modules/appState";
import batchOperations from "../../modules/batchOperations";
import { calendarSelectors } from "../../modules/definition/calendar";
import { isDateValid } from "../../modules/definition/calendar/dateFunctions";
import { stringFromDate, stringFromDateRange } from "../../modules/definition/calendar/dateFunctions/stringFromDate";
import { isTimespanZero, stringFromTimespan } from "../../modules/definition/calendar/dateFunctions/timespanFunctions";
import { itemOperations } from "../../modules/items";
import { uiStateSelectors } from "../../modules/uiState";
import { PropTypeShapes } from "../../types";
import { mergeDispatchToProps } from "../../utils/codeSplit";
import { listToMap } from "../../utils/immutableExtensions";
import preprocessorQuery from "../../utils/preprocessorQuery";
import { trackEvent } from "../../utils/trackAnalytics";
import InspectorAttachmentsTab from "./InspectorAttachmentsTab";
import InspectorConstraintsTab from "./InspectorConstraintsTab";
import InspectorPositionTab from "./InspectorPositionTab";
import InspectorPropertyTab from "./InspectorPropertyTab";
import InspectorRelationshipTab from "./InspectorRelationshipTab";
import InspectorTopBox from "./InspectorTopBox";
import selectors from "./selectors";

const isIos = preprocessorQuery.isIos();

//#!if iOS === true
// const dateRangeStringBuilder = (calendar, earliest, latest, hasUncertainStart, hasUncertainEnd, ongoing) =>
// isDateValid(earliest)
// ? isDateValid(latest)
// ? stringFromDateRange(calendar, earliest, latest, {}, false, hasUncertainStart, hasUncertainEnd, ongoing)
// : stringFromDate(calendar, earliest)
// : null;
// 
// const positionPreview = useProps => {
// const { calendar, itemData } = useProps;
// const dateRange = dateRangeStringBuilder(
// calendar,
// itemData.startDate,
// itemData.endDate,
// isDateValid(itemData.latestStartDate),
// isDateValid(itemData.earliestEndDate),
// itemData.ongoing
// );
// const duration =
// !isNil(itemData.preferredDuration) && !isTimespanZero(itemData.preferredDuration)
// ? !isNil(itemData.preferredDuration.label)
// ? itemData.preferredDuration.label
// : stringFromTimespan(itemData.preferredDuration)
// : null;
// 
// let lockIcon = null;
// if (itemData.isDateLocked) {
// lockIcon = <Icon icon="inspectorScrollLock" color="iconMid" />;
// }
// 
// const dateLine =
// dateRange || duration ? (
// <InspectorField>
// <span>
// {lockIcon}
// {dateRange ? dateRange : ""}
// {duration ? (dateRange ? ` (${duration})` : duration) : ""}
// </span>
// </InspectorField>
// ) : null;
// 
// const narrativeLine = itemData.narrativeDisplayLabel ? (
// <InspectorField>
// <span>{itemData.narrativeDisplayLabel}</span>
// </InspectorField>
// ) : null;
// 
// return (
// <Fragment>
// {dateLine}
// {narrativeLine}
// </Fragment>
// );
// };
// 
// const constraintsPreview = useProps => {
// const { itemData } = useProps;
// const dependenciesCount = itemData.blockingDependencies.size + itemData.blockedByDependencies.size;
// const constraintsCount = itemData.dateConstraints.size;
// 
// if (dependenciesCount > 0 || constraintsCount > 0) {
// return (
// <InspectorField>
// <span>
// {dependenciesCount > 0
// ? `${dependenciesCount} ${dependenciesCount > 1 ? "dependencies" : "dependency"}`
// : null}
// {dependenciesCount > 0 && constraintsCount > 0 ? ", " : null}
// {constraintsCount > 0 ? `${constraintsCount} ${constraintsCount > 1 ? "constraints" : "constraint"}` : null}
// </span>
// </InspectorField>
// );
// }
// return null;
// };
// 
// const countRelationships = (itemData, typeData) => {
// const { relationshipsByRefType, inverseRelationshipsByRefType } = itemData;
// const referenceMap = listToMap(typeData.references);
// 
// let sum = relationshipsByRefType.toList().flatten().size;
// inverseRelationshipsByRefType.forEach((relList, refId) => {
// const ref = referenceMap.get(refId);
// if (ref && (ref.showInverse || ref.bidirectional)) {
// sum += relList.size;
// }
// });
// return sum;
// };
// 
// const relationshipsPreview = useProps => {
// const { itemData, typeData } = useProps;
// 
// const relationshipsCount = countRelationships(itemData, typeData);
// 
// if (relationshipsCount > 0) {
// return (
// <InspectorField>
// <span>{`${relationshipsCount} ${relationshipsCount > 1 ? "relationships" : "relationship"}`}</span>
// </InspectorField>
// );
// }
// return null;
// };
// 
// const propertiesPreview = useProps => {
// const { itemData } = useProps;
// const propertyCount = itemData.propertyValues.size + (itemData.summary ? 1 : 0);
// const tagCount = itemData.tags.size;
// 
// if (propertyCount > 0 || tagCount > 0) {
// return (
// <InspectorField>
// <span>
// {propertyCount > 0 ? `${propertyCount} ${propertyCount > 1 ? "properties" : "property"}` : null}
// {propertyCount > 0 && tagCount > 0 ? ", " : null}
// {tagCount > 0 ? `${tagCount} ${tagCount > 1 ? "tags" : "tag"}` : null}
// </span>
// </InspectorField>
// );
// }
// return null;
// };
// 
// const attachmentsPreview = useProps => {
// const { itemData } = useProps;
// const attachmentCount = itemData.attachments.size + (itemData.image ? 1 : 0);
// const linkCount = itemData.links.size;
// 
// if (attachmentCount > 0 || linkCount > 0) {
// return (
// <InspectorField>
// <span>
// {attachmentCount > 0 ? `${attachmentCount} ${attachmentCount > 1 ? "attachments" : "attachment"}` : null}
// {attachmentCount > 0 && linkCount > 0 ? ", " : null}
// {linkCount > 0 ? `${linkCount} ${linkCount > 1 ? "links" : "link"}` : null}
// </span>
// </InspectorField>
// );
// }
// return null;
// };
//#!endif

const getDateAndNarrativeTab = props => {
  const { canHaveDate, canIncludeInNarrative } = props.typeData;
  if (isIos && !canHaveDate && !canIncludeInNarrative) {
    return null;
  } else {
    const label = `${canHaveDate ? "Date" : ""}${canHaveDate && canIncludeInNarrative ? " & " : ""}${
      canIncludeInNarrative ? "Narrative" : ""
    }`;
    return {
      icon: "inspectorTime",
      label,
      itemLabel: props.itemData.label,
      itemColor: props.itemData.swatchColor,
      interfaceId: interfaceIdentifiers.INSPECTOR_DATES_TAB,
      view: <InspectorPositionTab itemData={props.itemData} itemIds={props.itemIds} typeData={props.typeData} />,
      preview: isIos ? positionPreview(props) : null
    };
  }
};

const tabViews = props => {
  const showConstraints = !isIos || props.typeData.canHaveDate;
  const itemLabel = props.itemData.label;
  const itemColor = props.itemData.swatchColor;

  let tabs = [
    {
      icon: "inspectorRelationships",
      label: "Relationships",
      itemLabel,
      itemColor,
      interfaceId: interfaceIdentifiers.INSPECTOR_RELATIONSHIPS_TAB,
      view: <InspectorRelationshipTab itemData={props.itemData} itemIds={props.itemIds} typeData={props.typeData} />,
      preview: isIos ? relationshipsPreview(props) : null
    },
    {
      icon: "inspectorProperties",
      label: "Properties",
      itemLabel,
      itemColor,
      interfaceId: interfaceIdentifiers.INSPECTOR_PROPERTIES_TAB,
      view: <InspectorPropertyTab itemData={props.itemData} itemIds={props.itemIds} typeData={props.typeData} />,
      preview: isIos ? propertiesPreview(props) : null
    },
    {
      icon: "inspectorAttachments",
      label: "Image, Attachments & Links",
      itemLabel,
      itemColor,
      interfaceId: interfaceIdentifiers.INSPECTOR_ATTACHMENTS_TAB,
      view: <InspectorAttachmentsTab itemData={props.itemData} itemIds={props.itemIds} typeData={props.typeData} />,
      preview: isIos ? attachmentsPreview(props) : null
    }
  ];

  if (showConstraints) {
    const constraintsTab = {
      icon: "inspectorConstraints",
      label: "Constraints",
      itemLabel,
      itemColor,
      badge: props.violatedConstraintCount,
      badgeColor: "statusError",
      interfaceId: interfaceIdentifiers.INSPECTOR_CONSTRAINTS_TAB,
      view: <InspectorConstraintsTab itemData={props.itemData} itemIds={props.itemIds} typeData={props.typeData} />,
      preview: isIos ? constraintsPreview(props) : null
    };

    tabs.unshift(constraintsTab);
  }

  const dateAndNarrativeTab = getDateAndNarrativeTab(props);

  if (dateAndNarrativeTab) {
    tabs.unshift(dateAndNarrativeTab);
  }

  return tabs;
};

const onDeleteItems = (objIds, executeFunction) => {
  dialogs.okCancelPrompt("Are you sure you want to delete this item?", result => {
    if (result) {
      executeFunction(objIds);
    }
  });
};

const Inspector = props => {
  const isIos = preprocessorQuery.isIos();
  const { onDefaultCollapseClick, onCollapseClick } = props;

  const style = {};
  //#!if mobile === true
// style.paddingLeft = props.paddingLeft;
// style.paddingRight = props.paddingRight;
  //#!endif

  let thisOnCollapseClick = null;
  let showCollapseLeft = false;

  // #!if iOS === true
// showCollapseLeft = true;
  // #!endif

  thisOnCollapseClick = props.hideCollapse
    ? null
    : useCallback(() => {
      if (onCollapseClick) {
        onCollapseClick();
      } else {
        onDefaultCollapseClick();
      }
    }, [onDefaultCollapseClick, onCollapseClick]);

  const collapseText = props.collapseText ? props.collapseText : "Back";

  // // Example: deliberately trigger crash caught by React ErrorBoundary
  // if (props.itemIds.size === 0) {
  //   console.log(null[0]);
  // }

  return (
    <div className="inspector" style={style}>
      <TabLock autoFocus={false}>
        {props.itemIds.size === 0 ? (
          <InspectorEmptyBox
            key="content"
            onCollapseClick={thisOnCollapseClick}
            showCollapseLeft={showCollapseLeft}
            collapseText={collapseText}
          />
        ) : (
          <Fragment>
            <InspectorTopBox
              itemData={props.itemData}
              items={props.items}
              itemIds={props.itemIds}
              typeData={props.typeData}
              onCollapseClick={thisOnCollapseClick}
              showCollapseLeft={showCollapseLeft}
              collapseText={collapseText}
            />
            {!isIos ? (
              <TabView
                tabs={tabViews(props)}
                flatten={false}
                showLabels={false}
                activeTab={props.activeTab}
                onTabChange={props.onTabChange}
                pulsateIconId={props.pulsateIconId}
              />
            ) : (
              <DrawerView tabs={tabViews(props)} allowPortal={true} itemIds={props.itemIds} />
            )}
            <InspectorBottomBox
              itemIds={props.itemIds}
              onDeleteItems={itemIds => onDeleteItems(itemIds, props.onDeleteItems)}
              deleteLabel="Delete Item"
              tooltip="Delete item from entire timeline"
            />
          </Fragment>
        )}
      </TabLock>
    </div>
  );
};

Inspector.propTypes = {
  itemIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  itemData: PropTypeShapes.inspectorItem,
  items: PropTypeShapes.inspectorItemList,
  typeData: PropTypeShapes.denormalisedTypeDefinition,
  activeTab: PropTypes.number.isRequired,
  onTabChange: PropTypes.func.isRequired,
  onDeleteItems: PropTypes.func.isRequired,
  onDefaultCollapseClick: PropTypes.func.isRequired,
  hideCollapse: PropTypes.bool,
  onCollapseClick: PropTypes.func,
  collapseText: PropTypes.string,
  calendar: PropTypeShapes.calendar.isRequired,
  pulsateIconId: PropTypes.string,

  // From withContainerContext
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number
};

const mapStateToProps = state => {
  const inspectorData = selectors.getInspectorData(state.present);
  return {
    itemIds: inspectorData.itemIds,
    items: inspectorData.items,
    itemData: inspectorData.itemData,
    typeData: inspectorData.typeData,
    violatedConstraintCount: inspectorData.violatedConstraintCount,
    activeTab: appStateSelectors.getInspectorTab(state.present),
    calendar: calendarSelectors.getCalendar(state.present),
    pulsateIconId: uiStateSelectors.getPulsateIconId(state.present)
  };
};

const readonlyActions = {
  onTabChange: appStateOperations.changeInspectorTab,
  onDefaultCollapseClick: () => {
    trackEvent("inspectorCollapse", "UI");
    let action = null;
    // #!if iOS === true
// action = batchOperations.hideLeftPanelAndClearSelection();
    // #!else
    action = appStateOperations.hideRightPanel();
    // #!endif
    return action;
  }
};

const editingActions = {
  onDeleteItems: objIds => {
    trackEvent("deleteItemFromInspector", "deleteItem");
    return itemOperations.deleteItems(objIds);
  }
};

const mapDispatchToProps = dispatch => mergeDispatchToProps(readonlyActions, editingActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withContainerContext(Inspector));
